/**
 * Tagged template literal for syntax highlighting and formatting
 * example: html`<div />`
 * @param {String} strings - Template string
 * @param  {...any} values - dynamic values e.g. ${2+3}
 * @returns String
 */
export const html = (strings, ...values) =>
  String.raw({ raw: strings }, ...values);

/**
 * Update URL using window.history.replaceState
 * @param {String} path - takes a url parent category or object, ex: products or collections
 * @param {String} handle - takes a product.handle, collection.handle, or other object's return value, ex: bridesmaids-dresses or mia-shiny-satin-convertible-dress-sea-glass
 * */

export const updateUrl = (path, handle) => {
  window.history.replaceState(
    {},
    "",
    `${document.location.origin}/${path}/${handle}`,
  );
};
/**
 * Convert a string to title case
 * @param {String} string - Input string
 * @returns String
 */
export const toTitleCase = (string) =>
  string
    .replace(
      /\w\S*/g,
      (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase(),
    )
    .trim();

/**
 * Returns environment based configurations
 * @returns {Object} configs
 */
export const useConfig = () => {
  const { shop } = window.Shopify;
  const ENVIRONMENT =
    shop === "birdygrace.myshopify.com" ? "production" : "development";
  const config = {
    development: {
      platform_url: "https://platform.birdystaging.com/api",
      storefront_api_token: "a7cd863c8179b07652150b5bb739a07b",
      storefront_api_version: "2024-07",
    },
    production: {
      platform_url: "https://platform.birdygrey.com/api",
      storefront_api_token: "1a8f4e31c69ef2d8fe9c05d65c8c8f0e",
      storefront_api_version: "2024-07",
    },
  };

  const {
    platform_url: platformURL,
    storefront_api_token: storefrontApiAccessToken,
    storefront_api_version: storefrontApiVersion,
  } = config[ENVIRONMENT];
  return { platformURL, storefrontApiAccessToken, storefrontApiVersion };
};

/**
 * Returns payload within an array if not already an array.
 * @param {Object} payload
 * @returns {Array}
 */
export const convertPayloadToArray = (payload) => {
  if (!payload) return [];
  return Array.isArray(payload) ? payload : [payload];
};

/**
 * Convert the values into handles to use for populating swatch products.
 *
 * Handles are lowercased, hyphenated strings.
 * Ex: "Sea Glass" -> "sea-glass"
 *
 * @param {string[]} values - Array of strings.
 * @returns {string[]} handles - A new array of handles.
 */
export const convertValuesToHandles = (values = []) => {
  const handles = values.map((value) =>
    value.toLowerCase().trim().replace(/\s+/g, "-"),
  );

  return handles;
};

export default {};

/**
 * Determines the current domain based on the hostname
 * @returns {string} domain only, no subdomain
 */
export const getRootDomain = () => {
  const { hostname } = window.location; // e.g. www.birdygrey.com

  if (hostname === "127.0.0.1" || hostname === "localhost") {
    return hostname;
  }

  const domain = hostname.split(".").slice(1).join(".");
  return domain;
};
